export default "__VITE_ASSET__CA0GT84b__"